import React, {Component} from 'react'
import KoszykService from "../KoszykService";
import FirmyFormComponent from "../../konto/panel/panelComponents/mojeBiletyComponents/FirmyFormComponent";
import Button from "react-bootstrap/lib/Button";
import BiletyMiesieczneService from "../../konto/panel/panelComponents/mojeBiletyComponents/BiletyMiesieczneService";
import AppConfig from "../../AppConfig";

export default class WeryfikacjaFirmy extends Component {

    constructor(props) {
        super(props);

        this.state = {
            edytujFirme: false,
            nowaFirma: 0,
            firmaDoFaktury: '',
            loading: true
        }
    }

    componentDidMount() {
        KoszykService.getFirma(this.props.dokumentItem.nipParagon).then((response) => {
            if (response.data.content.length === 0) {
                this.setState({
                    firmaDoFaktury: {
                        nip: this.props.dokumentItem.nipParagon,
                        nazwa: '',
                        regon: '',
                        miejscowosc: '',
                        kodPocztowy: '',
                        ulica: '',
                        nrNieruchomosci: '',
                        nrLokalu: '',
                        wojewodztwo: '',
                        powiat: '',
                        gmina: '',
                        poczta: '',
                        formaPrawna: '',
                        formaSzczegolowaNazwa: '',
                        idFi: 0,
                    }, nowaFirma: 1, edytujFirme: true, loading: false
                })
            } else {
                this.setState({firmaDoFaktury: response.data.content[0], loading: false})
            }
        })
    }

    generujFakture() {
        this.setState({buttonLoader: true})
        KoszykService.postZamianaNaFaktura(this.props.dokumentItem.symNum, this.props.idBi, this.state.firmaDoFaktury.idFi, this.props.dokumentItem.tab).then((response) => {
            this.setState({buttonLoader: false})
            window.open(AppConfig.HOST_API() + 'client/api/faktury/generujFakture/biletJednorazowy/' + this.props.idBi + '/' + this.props.dokumentItem.tab + '/' + this.props.dokumentItem.symNum, '_blank');
            this.props.goBack()
        })
    }

    onClickZapiszFirme(obj, czyEdycja) {
        if (this.state.firmaDoFaktury.idFi !== 0) {
            KoszykService.editFirma(this.state.firmaDoFaktury.idFi, obj).then(function (response) {

                let obiekt = this.state.firmaDoFaktury;
                obiekt['nazwa'] = obj.nazwa;
                obiekt['kodPocztowy'] = obj.kodPocztowy;
                obiekt['regon'] = obj.regon;
                obiekt['miejscowosc'] = obj.miejscowosc;
                obiekt['nrLokalu'] = obj.nrLokalu;
                obiekt['nrNieruchomosci'] = obj.nrNieruchomosci;
                obiekt['ulica'] = obj.ulica;
                obiekt['wojewodztwo'] = obj.wojewodztwo;
                obiekt['informacje'] = obj.nip + ' ' + obj.nazwa;

                this.setState({
                    firmaDoFaktury: obiekt,
                    edytujFirme: false,
                    nowaFirma: 0
                })

            }.bind(this))
        } else {
            KoszykService.addFirma(obj).then(function (response) {
                if (response) {
                    if (response.data) {
                        this.setState({
                            firmaDoFaktury: Object.assign(response.data, {informacje: response.data.nip + ' ' + response.data.nazwa}),
                            edytujFirme: false,
                            nowaFirma: 0
                        })
                    }
                }
            }.bind(this))
        }
    }

    render() {
        return <div>
            <div className="row" style={{alignItems: 'center', width: '90%', margin: '0 auto'}}>
                <div className="col-12">
                    <div className="row">
                        <div className={'col-12'}>
                            <h2 className="text-center" style={{fontWeight: 'bold'}}>Dane firmy</h2>
                        </div>
                        <div className="col-12">
                            {this.state.loading ? 'Ładowanie...' : <div>{this.state.edytujFirme ?
                                <FirmyFormComponent edytowanaFirma={this.state.firmaDoFaktury}
                                                    nowaFirma={this.state.nowaFirma}
                                                    handleClickAnuluj={() => this.props.goBack()}
                                                    handleClickZapisz={(obj, czyEdycja) => this.onClickZapiszFirme(obj, czyEdycja)}/> :
                                <div>
                                    <hr/>
                                    <div className="row">
                                        <div className={'col-lg-12 text-center:'} style={{padding: '15px'}}>
                                            <b>Firma, na którą zostanie wystawiona
                                                faktura:</b>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <div style={{
                                                color: 'grey', fontWeight: 'bold'
                                            }}>Dane podstawowe:
                                            </div>
                                            <div style={{marginTop: 5}}>
                                                <label>Nazwa:</label> {this.state.firmaDoFaktury.nazwa}
                                            </div>
                                            <div><label>NIP:</label> {this.state.firmaDoFaktury.nip}
                                            </div>
                                            {
                                                Boolean(this.state.firmaDoFaktury.regon) ?
                                                    <div>
                                                        <label>REGON:</label> {this.state.firmaDoFaktury.regon}
                                                    </div>
                                                    :
                                                    ''
                                            }
                                        </div>
                                        <div className="col-lg-4">
                                            <div style={{
                                                color: 'grey', fontWeight: 'bold'
                                            }}>Adres:
                                            </div>
                                            <div style={{marginTop: 5, lineHeight: '32px'}}>
                                                {Boolean(this.state.firmaDoFaktury.ulica) ? this.state.firmaDoFaktury.ulica : ''} {Boolean(this.state.firmaDoFaktury.nrNieruchomosci) ? this.state.firmaDoFaktury.nrNieruchomosci : ''}{Boolean(this.state.firmaDoFaktury.nrLokalu) ? '/' + this.state.firmaDoFaktury.nrLokalu : ''}
                                            </div>
                                            <div>
                                                {Boolean(this.state.firmaDoFaktury.kodPocztowy) ? this.state.firmaDoFaktury.kodPocztowy : ''} {this.state.firmaDoFaktury.miejscowosc}{Boolean(this.state.firmaDoFaktury.wojewodztwo) ? ', ' + this.state.firmaDoFaktury.wojewodztwo : ''}
                                            </div>
                                        </div>
                                        <div className="col-lg-4 text-right">
                                            <Button
                                                onClick={() => this.setState({edytujFirme: true})}
                                                titleContent={'Edytuj dane firmy'}
                                                style={{background: '#ffc107', color: '#fff'}}>Edytuj
                                            </Button>
                                        </div>
                                    </div>
                                </div>}</div>
                            }
                        </div>
                        {this.state.edytujFirme ? null : <div className={'col-12 text-right'}>
                            <hr/>
                            <button className={'btn'} onClick={() => this.props.goBack()}
                                    style={{background: '#ffc107', color: '#fff', marginRight: 5}}>Wstecz
                            </button>
                            <button className={'btn btn-success'} disabled={this.state.buttonLoader} onClick={() => this.generujFakture()}>Generuj
                                fakturę
                            </button>
                            {this.state.buttonLoader ?
                                <div className="loaderDim" style={{marginTop: 5}}><i
                                    className="fa fa-spinner fa-pulse fa-fw"
                                    style={{
                                        color: '#58b13d'
                                    }}> </i></div> : null}
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/koszyk/fakturyComponents/WeryfikacjaFirmy.js